import Vue from 'vue';
import * as Vuex from 'vuex';
import { getStoreAccessors } from 'vuex-typescript';
import { State } from './state';

Vue.use(Vuex);

type Context = Vuex.ActionContext < State, State > ;

const state: State = {

    loaderActive: false,

    auth: {
        isLoggedIn: false,
        isCheckingSession: true,
        user: undefined,
    },

    socket: {
        isConnected: false,
        message: '',
        reconnectError: false
    }

};

const getters = {
    getLoaderState(state: State) {
        return state.loaderActive;
    },
    getLoggedInState(state: State) {
        return state.auth.isLoggedIn;
    },
    getLoggedInUser(state: State) {
        return state.auth.user;
    },
    getCheckingSession(state: State) {
        return state.auth.isCheckingSession;
    },
    getWebsocketsState(state: State) {
        return state.socket.isConnected;
    },
    getWebsocketsMessage(state: State) {
        return state.socket.message;
    },
};

const mutations = {
    setLoaderVisibility(state: State, loaderState: boolean) {
        state.loaderActive = loaderState;
    },
    setCheckingSession(state: State, checkingState: boolean) {
        state.auth.isCheckingSession = checkingState;
    },
    setLoggedInState(state: State, loggedInState: boolean) {
        state.auth.isLoggedIn = loggedInState;
    },
    setLoggedInUser(state: State, userData: any) {
        state.auth.user = userData;
    }
};

const actions = {
    loginUser(context: Context, loggedInState: boolean) {
        commitLoggedInState(context, loggedInState);
    },
};

export const createStore = () => new Vuex.Store < State >({
    state,
    getters,
    mutations,
    actions,
});

const { read, commit, dispatch } = getStoreAccessors < State, State >('');


/** ********************************************** */
/* GETTERS */
/** ********************************************** */
export const readLoaderVisibility = read(getters.getLoaderState);
export const readLoggedInState = read(getters.getLoggedInState);
export const readLoggedInUser = read(getters.getLoggedInUser);
export const readCheckingSession = read(getters.getCheckingSession);


/** ********************************************** */
/* MUTATIONS */
/** ********************************************** */
export const commitLoaderVisibility = commit(mutations.setLoaderVisibility);
export const commitCheckingSession = commit(mutations.setCheckingSession);
export const commitLoggedInState = commit(mutations.setLoggedInState);
export const commitLoggedInUser = commit(mutations.setLoggedInUser);

/** ********************************************** */
/* ACTIONS */
/** ********************************************** */
export const dispatchLoginUser = dispatch(actions.loginUser);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/store/store.ts